import './header.css';
import headerLogo from '../../assets/GovEx_Logo.png';


const Header = ({ bannerContent }) => {


    return (
        <>
            <header className="header">

                <nav>
                    <a href="/" className="logo"><img src={headerLogo} alt="GovEx Logo" className="logo-image" /></a>
                    <a href='https://govex.jhu.edu/' className='header-govex-btn'>GovEx</a>
                </nav>
                
            </header>
            {/* {bannerContent && */}
                <div className="header-banner" style={{height: bannerContent ? '100px' : '0px' }}>
                    <p>{bannerContent}</p>
                </div>
            {/* } */}

        </>

    );
};

export default Header;